<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { fly, fade } from "svelte/transition";
  import { XIcon, ShoppingCartIcon } from "svelte-feather-icons";
  import LoadingMask from "./LoadingMask.svelte";
  import Quantity from "./Cart/Quantity.svelte";

  let checked;
  let isChecked;
  let text = "";
  let mask;
  let isLoading = true;

  let insuranceProduct;
  let crossellProducts;
  let cartItem;
  let cartItems = [];
  let cartTotals;
  let crossItem = [];
  let leaseMonths = "48";
  let secondItems;
  let productIds = [];

  export let cartItemKey;

  const dispatch = createEventDispatcher();

  onMount(async () => {
    document.body.classList.toggle("modal-is-open");

    isLoading = true;
    await findItemInCart();
    //await findProduct();
    //await refreshCart();
    isLoading= false;
  });

  async function refreshCart() {
    isLoading = true;
    console.log("loading...");
    const cartResponse = await fetchCart();
    cartItems = await cartResponse.items;
    cartTotals = await cartResponse.totals;
    console.log("done...", { cartItems, cartTotals });
    await setTotalQuantity();
    await findItemInCart();
    isLoading = false;
  }

  async function fetchCart() {
    const itemsRequest = await fetch(
      digi_object.cart_rest_url + "/get-cart?thumb=true",
      {
        headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
       },
        cache: "no-cache",
      }
    );
    const cartObject = await itemsRequest.json();

    const totalsRequest = await fetch(digi_object.cart_rest_url + "/totals", {
      cache: "no-cache",
    });
    const cartObjectTotals = await totalsRequest.json();

    return {
      items: Object.entries(cartObject).map((entries) => {
        return entries[1];
      }),
      totals: cartObjectTotals,
    };
  }

  async function findItemInCart() {
        const itemsRequest = await fetch(
            digi_object.cart_rest_url + "/get-cart?thumb=true",
            {
              headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              },
                cache: "no-cache",
            }
        );

        const cartObject = await itemsRequest.json();

        cartItem = cartObject[cartItemKey];

        console.log('cartitem', cartObject);
        console.log('item', cartItem);

    }

    // async function findProduct(){

    //   let storage = [{
    //     "id": cartItem['product_id'],
    //   }]

    //   const response = await fetch(
    //       `${digi_object.rest_url}/products`,
    //       {
    //           method: "POST",
    //           body: JSON.stringify({ products: storage }),
    //           headers: {
    //               "Content-Type": "application/json",
    //           },
    //       }
    //   );

    //   let results = await response.json();
     
    //   crossItem = results[0]['crossell'];

    //   insuranceProduct = crossItem.find(id => id.id === 10653);
    //   //crossellProducts = crossItem.find(id => id.id !== 681);
    // }

  async function setTotalQuantity() {
    const totalQuantity = cartItems
      .map((item) => {
        return item.quantity;
      })
      .reduce((a, b) => a + b, 0); // add up all numbers

    const cartCounter = document.querySelector(".cart-count");
    if (cartCounter) {
      cartCounter.innerHTML = totalQuantity;
    }
  }

  async function deleteCartItem(key) {
    isLoading = true;
    const request = await fetch(digi_object.cart_rest_url + "/item", {
      method: "DELETE",
      headers: {
        "content-type": "application/json",
      },
      cache: "no-cache",
      body: JSON.stringify({
        cart_item_key: key,
      }),
    });

    const response = await request.json();

    await refreshCart();

    return true;
  }


  function addToArray(productId){
        const index = productIds.indexOf(productId);
        productIds.indexOf(productId) === -1 ? productIds.push(productId) : productIds.splice(index, 1);
        console.log(productIds);
    }

    function removeFromArray(productId){
        const index = productIds.indexOf(productId);
        productIds.indexOf(productId) === -1 ? productIds.remove(productId) : productIds.splice(index, 1);
    }

    function addToCart(items){
      secondItems = items.join();
      window.location.href= `${digi_object.site_url}/winkelmand/?add-to-cart=${secondItems}&quantity=${cartItem['quantity']}`;
    }

  function handleMaskClick(e) {
    if (e.target === mask) {
      dispatch("close");
    }
  }

  async function handleQuantityChange(key, quantity) {
    isLoading = true;
    const request = await fetch(digi_object.cart_rest_url + "/item", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      cache: "no-cache",
      body: JSON.stringify({
        cart_item_key: key,
        quantity: parseInt(quantity),
        refresh_totals: true,
      }),
    });

    const response = await request.json();

    await refreshCart();

    return true;
  }
</script>

<div
    class="modal-mask"
    transition:fade={{ duration: 250 }}
    bind:this={mask}
    on:click|stopPropagation={handleMaskClick}
>
    <div class="cart" transition:fly={{ x: 300 }}>
        <div class="cart__body" class:is-bundle={!isLoading && cartItem && cartItem.woosb_price}>
            {#if isLoading}
            <h3>
                <svg
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M12.5 0C5.62813 0 0 5.62813 0 12.5C0 19.3719 5.62813 25 12.5 25C19.3719 25 25 19.3719 25 12.5C25 5.62813 19.3719 0 12.5 0ZM9.99687 18.75L3.74688 12.5L5.5 10.7484L9.99687 15.2531L19.5 5.75L21.2531 7.50156L9.99687 18.75Z"
                      fill="#00A527"
                    />
                </svg>
                <span>Bijna van jou</span>
                <button type="button" class="close-button d-lg-none" on:click={() => dispatch("close")}>
                  <svg class="icon icon--size-4 icon--color-white" aria-hidden="true" viewBox="0 0 19 19" focusable="false"><path transform="rotate(45 9.5 9.5)" d="M0 9.5c0-1 1-2 2-2h5.5V2c0-1 1-2 2-2s2 1 2 2v5.5H17c1 0 2 1 2 2s-1 2-2 2h-5.5V17c0 1-1 2-2 2s-2-1-2-2v-5.5H2c-1 0-2-1-2-2z"></path></svg>
                </button>
            </h3>
                <!-- <LoadingMask  /> -->
            {:else}
                <div>
                    <h3>
                      <svg
                        width="25"
                        height="25"
                        viewBox="0 0 25 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12.5" cy="12.5" r="12.5" fill="white" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.5 0C5.62813 0 0 5.62813 0 12.5C0 19.3719 5.62813 25 12.5 25C19.3719 25 25 19.3719 25 12.5C25 5.62813 19.3719 0 12.5 0ZM9.99687 18.75L3.74688 12.5L5.5 10.7484L9.99687 15.2531L19.5 5.75L21.2531 7.50156L9.99687 18.75Z"
                          fill="#00A527"
                        />
                      </svg>
                      <span>Bijna van jou</span>
                      <button type="button" class="close-button" on:click={() => dispatch("close")}>
                        <svg class="icon icon--size-4 icon--color-white" aria-hidden="true" viewBox="0 0 19 19" focusable="false"><path transform="rotate(45 9.5 9.5)" d="M0 9.5c0-1 1-2 2-2h5.5V2c0-1 1-2 2-2s2 1 2 2v5.5H17c1 0 2 1 2 2s-1 2-2 2h-5.5V17c0 1-1 2-2 2s-2-1-2-2v-5.5H2c-1 0-2-1-2-2z"></path></svg>
                      </button>
                    </h3>
                    <div class="cart__product row justify-content-center align-items-center mb-4" in:fade>
                        {#if cartItem.woosb_price && cartItem.product_image}
                            <div class="col-lg-10 col-3">
                                <a
                                        class="cart__bundle-image"
                                        href={cartItem.product_permalink}
                                >
                                    <img src={cartItem.product_image} alt="Product image" />
                                </a>
                            </div>
                        {:else if cartItem.product_image}
                            <div class="col-lg-2 col-3">
                                <a
                                        class="cart__product-image"
                                        href={cartItem.product_permalink}
                                >
                                    <img src={cartItem.product_image} alt="Product image" />
                                </a>
                            </div>
                        {/if}

                        <div class="col-9 col-lg-10">
                            <div class="cart__product-info row">
                                <div class="col-lg-8">
                                    <a
                                        href={cartItem.product_permalink}
                                        class="cart__product-title"
                                    >
                                        {cartItem.product_title}
                                    </a>

                                    <p class="cart__product-price mb-2">
                                        {cartItem.line_total}
                                    </p>

                                    <p class="cart__product-quantity mb-2">
                                      <Quantity
                                        on:change={(e) =>
                                        handleQuantityChange(cartItem.key, e.detail)}
                                        quantity={cartItem.quantity}
                                      />
                                    </p>
                                </div>

                                <div class="cart__product-checkout col-lg-4">
                                    <button
                                        class="button button-green mb-3"
                                        on:click={() => (window.location.href = `${digi_object.site_url}/winkelmand`)}
                                    >
                                        Nu bestellen
                                    </button>
                                    <button
                                        class="button button-grey"
                                        on:click={() => dispatch("close")}
                                    >
                                        Verder winkelen
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            {/if}
        </div>

       
    </div>
</div>

<style lang="scss">
    
    .modal-mask {
        position: fixed;
        z-index: 9999999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        margin: auto;
        justify-content: center;
        align-items: center;
    }

    .product-image :global(img) {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    .cart__bundle-image {

    }

    .cart {
        width: 822px;
        background: #fff;
        position: fixed;
        right: auto;
        top: auto;
        left: auto;
        //height: 921px;
        bottom: auto;
        margin: auto;
        padding: 25px 20px;
        border-radius: 5px;

        &__body {

            padding-left: 10px;
            min-height: 160px;

            &.is-bundle {
              padding-bottom: 45px;

              h3 {
                margin-bottom: 30px;
              }
            }

            h3 {
                font-size: 16px;
                margin-bottom: 20px;
                padding-left: 10px;

                span {
                    margin-left: 10px;
                }
            }
        }

        #test {
            color: #d92127;
            font-weight: bold;
        }

        &__middle {
            padding-left: 15px;
            padding-right: 15px;
            padding-top: 15px;
            padding-bottom: 25px;
            width: 100%;
            //height: 380px;

            border-bottom: 2px solid #e3e3e3;

            h3 {
              font-size: 18px;
              margin-bottom: 15px;
            }

            div.w-100 {
                margin-bottom: 15px;

                label {
                    margin-right: 20px;
                }
            }

            & .product { 
              > div {
                padding: 0px 10px 1px 10px;
                box-shadow: 0 0 4px 0 rgba(0,0,0, .5);
                background: #fff;
                border-radius: 4px;
                cursor: pointer;
              }

              &.true {
                  > div {
                    border: 1px solid #00a527;
                  }

                  .check-image {
                    opacity: 1;
                    transition: ease-in .35s;
                  }

                  .checkbox {
                    opacity: 0;
                  }
              }

              .check-image {
                position: absolute;
                top: 6px;
                margin-bottom: 0;
                opacity: 0;
              }

              .checkbox {
                width: 15px;
                border: 1px solid #bbb;
                height: 15px;
                border-radius: 4px;
                position: absolute;
                top: 10px;
                opacity: 0;
              }

              &-image {
                width: 150px;
                height: 150px;
              }
              &-title {
                font-size : 12px;
                font-weight: bold;
                margin-bottom: 1.5rem;
              }
              &-price {
                font-size: 14px;
              }

            }
        }

        &__footer {
            padding-left: 50px;
            padding-right: 50px;
            padding-top: 25px;
            padding-bottom: 10px;
            width: 100%;
            //height: 327px;

            h3 {
              font-size: 18px;
              margin-bottom: 15px;
            }

            div.w-100 {
                margin-bottom: 15px;

                label {
                    margin-right: 20px;
                }
            }

            & .product { 
              > div {
                padding: 0px 10px 1px 10px;
                box-shadow: 0 0 4px 0 rgba(0,0,0, .5);
                background: #fff;
                border-radius: 4px;
                cursor: pointer;
              }

              &.true {
                  > div {
                    border: 1px solid #00a527;
                  }

                  .check-image {
                    opacity: 1;
                    transition: ease-in .35s;
                  }

                  .checkbox {
                    opacity: 0;
                  }
              }

              .check-image {
                position: absolute;
                top: 6px;
                margin-bottom: 0;
                opacity: 0;
              }

              .checkbox {
                width: 15px;
                border: 1px solid #bbb;
                height: 15px;
                border-radius: 4px;
                position: absolute;
                top: 10px;
                opacity: 1;
              }

              &-image {
                width: 150px;
                height: 150px;

              }
            
              &-title {
                font-size : 12px;
                font-weight: bold;
                margin-bottom: 1.5rem;
              }
              &-price {
                font-size: 14px;
              }

            }
        }

        &__checkout {
            button {
                display: block;
                margin-top: 10px;
                text-transform: lowercase;
                letter-spacing: normal;
                margin-right: 15px;
            }

            .button--orange {
                background-color: #fabe00 !important;
            }
        }

        &__product {
            display: flex;

            &-image {
                flex: 0 0 135px;

                img {
                    width: 135px;
                    height: 75px;
                    object-fit: cover;
                }
            }

            &-info {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                position: relative;
            }

            &-checkout {
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                justify-content: flex-end;

                .button {
                    width: 100%;
                    height: 45px;
                    color: #fff;
                    border: none;
                    border-radius: 4px;

                    &-green {
                        background-color: #26cb01 !important;
                        color: #fff;
                    }

                    &-grey {
                        background-color: #f0f0f0 !important;
                        color: #000;
                        margin-bottom: 20px;
                    }
                }
            }

            &-title {
                line-height: 1.2;
                font-weight: 400;
                font-size: 16px;
                width: 100%;
                color: #000;
                align-items: center;
                margin-bottom: 20px;
            }

            &-price {
                display: block;
                font-size: 18px;
                font-weight: 700;
                color: #2f2f2f;
                margin-bottom: 0;
                width: 100%;
            }

            &-price.no-tax {
                font-weight: 400;
                font-size: 14px;
                color: #25cb01;
            }
        }
    }



    @media (max-width: 991.98px) {
        .modal-mask {
            height: 100%;
            width: 90%;
            left: 0;
            margin: 0;
            background: #fff;
            display: block;

            &::before {
                content: '';
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                margin: auto;
                justify-content: center;
                align-items: center;

            }
        }

        .cart {
            width: 95%;
            height: 100%;
            right: unset;
            top: unset;
            display: flex;
            flex-flow: column;
            overflow: auto;
            position: relative;
            padding: 0;
            margin: 0;
            border-radius: 0;

            &__title {
                height: 75px;
            }

            &__body {
                height: 50%;
                border-bottom: none !important;
                padding-bottom: 0 !important;

                h3 {
                    margin-bottom: 20px;
                    background: #1081c4;
                    color: #fff;
                    padding: 15px 0;
                    font-size: 14px;
                    text-align: center;
                    margin: 0 0px 0 -10px;

                    svg {
                        display: none;
                    }

                    span {
                      margin-left: 0;
                    }

                    button.close-button {
                      background: none;
                      border: none;
                      position: absolute;
                      right: 10px;
                      top: 3px;

                      svg {
                        display: block;
                        fill: #fff;
                        width: 1.5rem;
                        height: 1.5rem;
                      }
                    }
                }
            }
            &__product-info {
                margin-top: 20px;
            }
            &__product {
                flex-direction: row;
                padding: 0 15px;
            }
            &__middle {
                padding: 20px 25px;
                border-top: 1px solid #e3e3e3;

                & h3 {
                    font-size: 15px;
                }
            }
            &__footer {
                padding: 20px 25px;
                margin-bottom: 80px;
            }
            &__product-checkout {
                flex-wrap: unset;
                justify-content: space-between;
                margin-top: 15px;
                position: fixed;
                bottom: 0;
                z-index: 99;
                left: 0;
                width: 85.6%;
                display: block;
                padding: 10px;
                background: #fff;

                .button {
                    width: 100%;

                    &-grey {
                        display: none;
                    }
                }
            }
        }
    }

    /*// Extra small devices (portrait phones, less than 576px)*/
    /*@media (max-width: 575.98px) { ... }*/

    /*// Small devices (landscape phones, less than 768px)*/
    /*@media (max-width: 767.98px) { ... }*/

    // Medium devices (tablets, less than 992px)

    // Large devices (desktops, less than 1200px)
    /*@media (max-width: 1199.98px) { ... }*/

    @media (max-width: 991.98px) {
      .cart__product-image :global(img) {
        width: 100% !important;
        height: 100% !important;
        object-fit: contain !important;
      }

      .cart__product-title {
        font-size: 14px !important;
      }
    }

    @media (min-width: 991.99px) {
      .modal-mask button.close-button {
          display: inline-block!important;
          background: 0 0;
          border: 0;
          position: absolute;
          right: 20px;
      }
    }

    @media (min-width: 991.99px) {
      .modal-mask button.close-button svg {
          display: block;
          fill: #e96432;
          width: 2rem;
          height: 2rem;
      }
    }

    
</style>
